import { render, staticRenderFns } from "./HomeDeleteHistory.vue?vue&type=template&id=2830d98f"
import script from "./HomeDeleteHistory.vue?vue&type=script&lang=js"
export * from "./HomeDeleteHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports